<template>
  <div class="hello">
    <img class="hello-hero-loader" v-for="n in heroCount" :key ="n" :src="'./heroes/wku-members-hero-' + n + '.jpg'" @load="onHeroLoaded($event)">
    <div class="hello-heroes" :class="{loading: heroCount > heroesLoaded}">
      <div class="hello-hero" v-for="n in heroCount" :key ="n" :style="'background-image: url(./heroes/wku-members-hero-' + n + '.jpg);'" :class="{active: heroIndex === n}" @load="onHeroLoaded($event)"></div>
    </div>
    <div class="hello-image"></div>
    
    <!--input class="hello-input-search" v-on:click="initSearchField()" v-model="searchText" type="text"></input-->
    
    <!--div class="debug">{{debugMessage}}</div-->

    <!--autocomplete-input class="hello-input-search" :options="memberArray" :placeholder="$t('message.searchForNameOrMap')" @select="onOptionSelect" @input="onAutoCompleteInput">
      <template slot="item" slot-scope="option">
        <div class="autocomplete-input-item">
          <div class="autocomplete-input-item-image-outer">
            <img :src="option.thumbnail" @error="onImageError"/>
          </div>          
          <div>
            <strong>{{ option.title }}</strong> <span class="light">MAP {{ option.remark }}</span>
            <div class="small">{{ option.subtitle }}</div>
          </div>
        </div>
      </template>
    </autocomplete-input-->
    <div class="hello-search-outer">
      <cool-select
          v-model="selectedMember"
          :items="memberArray"
          :placeholder="$t('message.searchForNameOrMap')"
          :disableFilteringBySearch="true"
          item-value="map"
          item-text="firstname"
          @search="onSearch"
          @select="goMember(selectedMember)">
          <template slot="item" slot-scope="{ item: member }">
            <div class="autocomplete-list-item">
              <div class="autocomplete-list-item-portrait">
                <img :src="member.memberImage" @error="onImageError"/>
              </div>
              <div>
                <b>{{ member.firstname }} {{ member.lastname }}</b>
              </div>
            </div>
          </template>        
        </cool-select>
    </div>
    
    <div class="hello-announcements">
      
      <div class="hello-announcement hello-events">
        <h3>{{$t('message.upcomingEvents')}}</h3>
          
            <transition-group class="hello-items-outer" name="slide" tag="div">
              <div class="hello-item hello-event" v-for="(event, index) in events.tournaments" v-bind:key="event.id" v-show="eventIndex === index"
                @click="goEvent(event.id)">
                <div class="hello-item-image"><img :src="posterPath + '?posterId=' + event.id + '&targetwidth=50&targetheight=75'"/></div>
                <div>
                  <h4>{{event.title}}</h4>
                  <div>{{event.city}}</div>
                  <div>{{event.startDate}}</div>
                </div>
              </div>
            </transition-group>
          
        <div class="hello-items-bullets">
          <span class="hello-items-bullet" v-bind:class="{active: eventIndex === index}" v-for="(event, index) in events.tournaments" v-on:click="eventIndex = index" :key="index">&bullet;</span>          
        </div>
      </div>
      
    </div>
    
  </div>
</template>

<script>
import _ from 'lodash'
import { mapGetters } from 'vuex'
import { CoolSelect } from 'vue-cool-select'

export default {
  name: 'hello',
  data () {
    return {
      searchText: '',
      eventIndex: 0,
      heroIndex: 1,
      heroCount: 10,
      heroesLoaded: 0,
      options: null,
      memberArray: [],
      selectedMember: null,
      debugMessage: ''
    }
  },
  components: {
    CoolSelect
  },
  methods: {
    initSearchField: function () {
      this.searchText = ''
    },
    onSearch: function (search) {
      console.log(search)
      if (search.length > 3) {
        this.getMembers(search)
      } else {
        this.$store.commit('members/SET_SEARCH', [])
      }
    },
    goMember (map) {
      this.$router.push('/member/' + map)
    },
    goEvent (id) {
      console.log(id)
      this.$router.push('/events')
    },
    onOptionSelect (option) {
      console.log('Selected option:', option)
      window.location.href = './#/member/' + option.map
    },
    onAutoCompleteInput: function (keyword) {
      this.debugMessage = keyword
      if (keyword.length > 3) {
        this.getMembers(keyword)
        // alert(keyword)
      } else {
        // this.members = {}
      }
    },
    updateDebug: function (event) {
      this.debugMessage = event.target.value
    },
    getMembers: function (searchString) {
      console.log('searching for: ' + searchString)
      this.$store.dispatch('members/search', searchString).then(() => {
        // this.getRepresentatives()
      })
    },
    getEvents: function () {
      this.$store.dispatch('events/getAll').then(() => {
        // done
      })
    },
    onImageError: function (event) {
      event.target.src = './person-dummy.png'
    },
    onHeroLoaded: function () {
      console.log('onHeroLoaded')
      this.heroesLoaded += 1
      if (this.heroesLoaded === this. heroCount) {
        this.startHeroLoop()
      }
    },
    startHeroLoop: function () {
      var self = this
      window.setInterval(() => {
        self.heroIndex++
        if (self.heroIndex > self.heroCount) {
          self.heroIndex = 1
        }
      }, 6000)
    }
  },
  computed: {
    ...mapGetters({
      members: 'members/searchResult',
      events: 'events/list',
      posterPath: 'events/eventPosterPath'
    })
  },
  created: function () {
    this.getEvents()
  },
  watch: {
    members: function (object) {
      this.memberArray = _.values(object)
      console.log(this.memberArray)
    }
  }
}

</script>
